export default {
  dashboard: 'داشبورد',
  heartPulse: 'Heart Pulse',
  SPO2: 'SPO2',
  falling: 'خروج',
  pulseRate: 'Pulse Rate',
  temperature: 'دما',
  state: 'وضعیت',
  charge: 'شارژ',
  warningType: 'نوع هشدار',
  warnings: 'هشدارها',
  standing: 'ایستاده',
  laying: 'دراز کشیده',
  ecg: 'ECG',
  callNotAnswer: 'تماس بی پاسخ',
  history: 'تاریخچه',
  online: 'آنلاین',
  bloodPressure: 'فشار خون',
  map: 'map',
  off: 'خاموش',
  warningTypesInfo: {
    HIGH_HEART_RATE: 'ضربان قلب بالا',
    LOW_HEART_RATE: 'ضربان قلب کم',
    HIGH_PULSE_RATE: 'سرعت ضربان بالا',
    LOW_PULSE_RATE: 'سرعت ضربان کم',
    HIGH_HEART_PULSE: 'ضربان قلب بالا',
    LOW_HEART_PULSE: 'ضربان قلب کم',
    HIGH_TEMPERATURE: 'دما بالا',
    LOW_TEMPERATURE: 'دما کم',
    HIGH_SPO2: 'SPO2 بالا',
    LOW_SPO2: 'SPO2 کم',
    UNDEFINED: 'نامشخص'
  }
}
